import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SharedService } from "./../../../shared/shared.service";
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PagingGridData } from "./../../models/paging-grid-data";
import { PujaPrasadMaster } from '../../../prasad-order/puja-prasad-master';
import { PujaPrasadService } from '../../../prasad-order/puja-prasad.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
//import { SearchGridEntity } from "./../../models/search-grid-entity";

@Component({
  selector: 'app-todays-puja',
  templateUrl: './todays-puja.component.html',
  styleUrls: ['./todays-puja.component.css'],
  providers: [AdminPrasadOrderService, PujaPrasadService, AdminMobileappService]
})
export class TodaysPujaComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService,
    private pujaPrasadService: PujaPrasadService,
    private adminMobileAppService: AdminMobileappService) { }

  devoteeList: DevoteeDetail[] = [];
  performPujaDateFrom: string;
  performPujaDateTo: string;
  pagingGridData: PagingGridData;
  errorMessage: string = "";
  successMessage: string = "";
  searchForm: FormGroup;
  pujaPrasadList: PujaPrasadMaster[] = [];

  ngOnInit() {
    this.createSearchForm();
    this.loadPujaPrasadList();
    // this.searchPrasadOrder();
  }

  searchPrasadOrder() {

    var searchFormValue = { ...this.searchForm.value };
    searchFormValue.PageNo = 0;

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchFormValue).subscribe(
      data => {
        console.log(data);
        this.pagingGridData = data.PrasadOrderVidhis;
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )
  }

  pujaPerformed() {

    var searchFormValue = { ...this.searchForm.value };

    searchFormValue.PageNo = 0;

    let pujaPrasadVidhiDetailIds = this.pagingGridData.PageData.map(x => x.PrasadOrderPujaVidhiId);

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.pujaPerformed(pujaPrasadVidhiDetailIds).subscribe(
      data => {
        console.log(data);
        this.successMessage = data;
        this.searchPrasadOrder();
      },
      err => {
        this.errorMessage = err;
      },
      () => this.sharedService.hideSpinner()
    )

  }


  sendWhatsAppMsgPujaPerformed() {


    var whatsAppMsgRequests = this.pagingGridData.PageData.map(x => {
      return {
        MsgType: "PujaVidhiPerformed",
        MobileNo: x.OnlinePujaPrasadOrder.MobileNo,
        DevoteeName: x.DevoteeDetail.FirstName,
        OrderId: x.OnlinePujaPrasadOrder.Id,
        TotalAmount: x.OnlinePujaPrasadOrder.Amount.toString(),
        PujaVidhiId: x.OnlinePujaPrasadOrder.PujaPrasadId,
        PujaVidhiName: this.pujaPrasadList.filter(y => y.Id === x.OnlinePujaPrasadOrder.PujaPrasadId)[0].TypeOfPuja,
        PujaVidhiDate: x.OnlinePujaPrasadOrder.OnWhichDate,
        IsMarathi: x.DevoteeDetail.State === 'Maharashtra'
      }
    })


    for (let i = 0; i < whatsAppMsgRequests.length; i++) {
      this.sharedService.showSpinner();
      this.adminMobileAppService.whatsAppMsgSend(whatsAppMsgRequests[i]).subscribe(
        data => {
          console.log(data);
          if (!data.status) {
            this.errorMessage = data.message;
            return;
          }
          this.successMessage = data.message;
        },
        err => {
          this.errorMessage = err;
          this.sharedService.hideSpinner();
        },
        () => this.sharedService.hideSpinner()
      )
    }
  }


  private loadPujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadService.getPujaDetails().subscribe(
      data => {
        this.pujaPrasadList = data;
        //this.prasadOrderSearch();
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  createSearchForm(): void {
    var todayDate = new Date();

    this.searchForm = this.formBuilder.group({
      PujaDateFrom: [this.datePipe.transform(todayDate, 'y-MM-dd')],
      PujaDateTo: [this.datePipe.transform(todayDate, 'y-MM-dd')],
      PujaVidhiId: [],
      PriceFrom: [],
      PriceTo: [],
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/admin/components/todays-puja/todays-puja.component.ts